import { useEffect, useRef } from 'react';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import {
  Swiper as SwiperComponent,
  SwiperRef,
  SwiperSlide,
} from 'swiper/react';

import { useModal } from 'components/elements/modal';
import OwnImage from 'components/elements/ownImage';
import GalleryNavigator from 'components/elements/plpCard/components/galleryNavigator';
import { Router } from 'next/router';
import { CgClose } from 'react-icons/cg';
import ImageGalleryTiles from './imageGalleryTiles';

interface Props {
  pdpId?: string;
  images: string[];
  onSlideChange?: (_swiper: Swiper) => void;
  size?: 'original' | 'small' | 'large';
}

function GallerySlider({ images, onSlideChange, pdpId, size = 'large' }: Props) {
  const swipper = useRef<SwiperRef>(null);

  const modal = useModal({
    id: `gallery-tile-${pdpId}`,
    closeable: true,
    content: ({ closeModal }) => (
      <div className="md:w-[60vw] w-[92vw] p-4">
        <div className="pb-2">
          <button
            className="flex items-center justify-center p-2 bg-transparent"
            onClick={closeModal}
          >
            <CgClose />
          </button>
        </div>
        <ImageGalleryTiles images={images} />
      </div>
    ),
  });

  useEffect(() => {
    Router.events.on('routeChangeStart', () => {
      modal.closeModal();
    });
  }, []);

  return (
    <div className="relative min-h-[16.25rem] !h-[53vh] md: md:max-w-[1000px] ">
      <SwiperComponent
        ref={swipper}
        spaceBetween={50}
        className="w-full h-full"
        modules={[Pagination, Navigation]}
        pagination={{
          clickable: true,
          horizontalClass: 'mb-3',
          dynamicBullets: true,
          renderBullet: function (_index, className) {
            return `<span class="w-2 h-2 bg-white ${className}" ></span>`;
          },
        }}
        // noSwiping
        // allowTouchMove={userDevice === 'MOBILE'}
        slidesPerView={1}
        onSlideChange={(swiper) => {
          if (onSlideChange) {
            onSlideChange(swiper);
          }
        }}
      >
        <GalleryNavigator imageCount={images.length} />
        {images.length > 0 ? (
          images.map((image) => (
            <SwiperSlide
              className="cursor-pointer"
              key={image}
              onClick={() => {
                modal.openModal();
              }}
            >
              <OwnImage
                src={(image != null) ? image.toString() + "?q=" + size : "/images/default-image.jpg"}
                alt={(image != null) ? image.toString() + "?q=" + size : "کیلید"}
                sizes="(max-width: 640px) 260px, (max-width: 768px) 533px, 1000px"
                className="w-full property-picture object-fill"
                // width={1000}
                // height={533}
                layout="fill"
              />
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide>
            <OwnImage
              src="/images/default-image.jpg"
              alt="default Image"
              className="w-full property-picture"
              sizes="(max-width: 640px) 260px, (max-width: 768px) 533px, 1000px"
              height={533}
              width={1000}
            />
          </SwiperSlide>
        )}
      </SwiperComponent>
    </div>
  );
}

export default GallerySlider;
